import { createContext, useContext } from 'react';

import { LivingInfoGroupedDataType } from '../types';

type AccommodationContentType = {
  livingInfoData: LivingInfoGroupedDataType[] | [];
};

export const AccommodationContext = createContext<AccommodationContentType>({
  livingInfoData: [],
});

export const useAccommodationContext = () => useContext(AccommodationContext);
